import { Heading, Tag, Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import './ServicesBlockItem.css';

const ServicesBlockItem = ({ item }) => {
  const content = (
    <>
      {!item.isReady && (
        <Tag
          className="soon-label"
          size="md"
          key={item.id}
          variant="solid"
          colorScheme="blue"
        >
          <FormattedMessage id="SoonText" />
        </Tag>
      )}
      <div className="services-block-item-inner">
        <Heading as="h3" size="lg">
          {item.heading}
        </Heading>
        <Text className="services-block-item-text" colorScheme="blue">
          {item.text}
        </Text>
      </div>
      {item.image}
      {item.link && <div>{item.icon}</div>}
    </>
  );

  if (item.path) {
    return (
      <Link to={item.path} className="services-block-item-link">
        <div className="services-block-item">
          {content}
        </div>
      </Link>
    );
  }

  return (
    <div className="services-block-item">
      {content}
    </div>
  );
};

export default ServicesBlockItem;
